import {Box, Button, Grid, makeStyles} from "@material-ui/core";
import {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import SearchActionsSection from "./SearchActionsSection";
import {showAlertSnackbar} from "../../../reducers/uiSlice";
import {useToken} from "../../../utilities/hooks";
import _ from 'lodash';
import {getUserPreference} from "../../../utilities/common";
import PublishIcon from "@material-ui/icons/Publish";
import AddIcon from "@material-ui/icons/Add";
import RefreshIcon from "@material-ui/icons/Refresh";
import FullscreenLoading from "../../Common/FullscreenLoading";
import UniDialog from "../../Common/UniDialog";
import PayRollTableSection from "./TableSection";
import PaymentAdjustmentDialog from "./PaymentAdjustmentDialog";
import {
    getPaymentCycle,
    getAllPayrolls,
    getChargeReason,
    viewPayroll,
    updateBatchPayroll,
    deletePayroll,
    downloadPayrollExcelBlob
} from "../../../actions/payRollAdjustmentAction";
import SelectPayrollDialog from "./SelectPayrollDialog";
import {downloadZipCodeExcelBlob} from "../../../actions/deliveryAreaActions";

const MANAGER_ACCESS_ROLE = 307;

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.default,
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        margin: 0
    },
    appBarClasses: {
        backgroundColor: theme.palette.background.default,
        color: theme.palette.text.primary,
        padding: theme.spacing(1)
    },
    topBarButton: {
        marginLeft: theme.spacing(2),
        color: 'unset',
        '&:hover': {
            color: theme.palette.text.primary
        }
    },
    buttonGroupStyle: {
        textAlign: 'right',
        marginTop: theme.spacing(4),
        marginBottom: theme.spacing(2)
    },
}))

function PayrollAdjustmentTable(props) {
    const dispatch = useDispatch();
    const classes = useStyles();
    const {t} = useTranslation('payrollAdjustment');
    const [manageIndex, setManageIndex] = useState('payroll');
    const tokenContents = useToken();
    const authorizedWarehouses = tokenContents.warehouse;
    const [isDataLoading, setIsDataLoading] = useState(false);
    const [openPayrollAdjustmentDialog, setOpenPayrollAdjustmentDialog] = useState(false);
    const [openUpdateParollDialog, setOpenUpdateParollDialog] = useState(false);
    const [allDriverDetails, setAllDriverDetails] = useState([]);
    const [selectedPaymentCycle, setSelectedPaymentCycle] = useState();
    const [status, setStatus] = useState(0);
    const [adjustmentType, setAdjustmentType] = useState('');
    const [award, setAward] = useState(0);
    const [amountFrom, setAmountFrom] = useState();
    const [amountTo, setAmountTo] = useState();
    const [payrollDialogType, setPayrollDialogType] = useState('');
    const [driverId, setDriverId] = useState();
    const [selected, setSelected] = useState(true);
    const [selectedItem, setSelectedItem] = useState();
    const [chargeReason, setChargeReason] = useState(null);
    const [searchedPayrollCyle, setSearchedPayrollCyle] = useState();
    const userPref = getUserPreference();
    const [disableSubmitButton, setDisableSubmitButton] = useState(false);
    const [payrollDetail, setPayrollDetail] = useState([]);
    const [payrollFileDetail, setPayrollFileDetail] = useState([]);
    const ableManagerAccess = tokenContents.uiAbilities.includes(MANAGER_ACCESS_ROLE);
    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
    const [deleteEntryID, setDeleteEntryID] = useState();
    const [timezone, setTimezone] = useState('');
    const [paymentCycleSelectType, setPaymentCycleSelectType] = useState('');
    const [warehouses, setWarehouses] = useState(userPref.userCity);
    const [payRollList, setPayRollList] = useState([
        {
            id: 0,
            label: t('payment_cycle'),
            key: "payment_cycle",
            list: {},
            onlyManagerAccess: false,
            length: 4
        },
        {
            id: 1,
            label: t('status'),
            list: [
                {
                    id: 0,
                    text: t('new_entry'),
                    value: 1
                },
                {
                    id: 1,
                    text: t('to_be_reviewed'),
                    value: 2
                },
                {
                    id: 2,
                    text: t('approval'),
                    value: 3
                }

            ],
            onlyManagerAccess: false,
            length: 2
        },
        {
            id: 2,
            label: t('deduction_subsidy'),
            list: [
                {
                    id: 0,
                    text: t('all'),
                    value: -1
                },
                {
                    id: 1,
                    text: t('deduction'),
                    value: 1
                },
                {
                    id: 2,
                    text: t('subsidy'),
                    value: 2
                }

            ],
            onlyManagerAccess: false,
            length: 2
        },
        {
            id: 3,
            label: t('reason'),
            list: [],
            onlyManagerAccess: true,
            length: 3
        }
    ]);
    const payRollInput = [
        {
            id: 0,
            label: t('amount_from'),
            specificSign: true
        },
        {
            id: 1,
            label: t('amount_to'),
            specificSign: false
        },
        {
            id: 2,
            label: t('driver_id'),
            specificSign: false
        }
    ]
    const payRollManagerButton = [
        {
            id: 0,
            label: t('payroll_adjustment'),
            colorButton: true
        },
        {
            id: 1,
            label: t('approve'),
            colorButton: false
        },
    ]
    const payRollAssitantButton = [
        {
            id: 0,
            label: t('payroll_adjustment'),
            colorButton: true
        },
        {
            id: 1,
            label: t('submit_for_review'),
            speciificSign: null
        }
    ]

    const handleManageIndex = (event) => {
        setManageIndex(event.target.value);
    }
    const handleOnsearch = (searchKeys, inputKeys, warehouses) => {
        if (!_.isNil(searchKeys[0]) && !_.isNil(searchKeys[1])) {
            setIsDataLoading(true);
            setSelectedPaymentCycle(searchKeys[0]?.toString());
            setStatus(searchKeys[1]);
            setAdjustmentType(searchKeys[3]);
            setAward(searchKeys[2]);
            setAmountFrom(inputKeys[0]);
            setAmountTo(inputKeys[1]);
            setDriverId(inputKeys[2]);
            setWarehouses(warehouses);
            let params = {
                payment_cycle: searchKeys[0],
                status: searchKeys[1],
                charge_reason: searchKeys[3],
                deduction_subsidy: searchKeys[2],
                amount_from: inputKeys[0],
                amount_to: inputKeys[1],
                driver_id: inputKeys[2],
                warehouse: warehouses
            }
            dispatch(getAllPayrolls(params))
                .then((res) => {
                    if (_.isNil(res)) {
                        dispatch(showAlertSnackbar({message: "No Data Found", type: 'error'}))
                    } else {
                        setAllDriverDetails(res);
                        setSearchedPayrollCyle(searchKeys[0])
                        setStatus(searchKeys[1]);
                    }
                })
                .catch((err) => {
                    setAllDriverDetails([]);
                    dispatch(showAlertSnackbar({message: err.message, type: 'error'}))
                })
                .finally(() => {
                    setIsDataLoading(false);
                })
        } else
            dispatch(showAlertSnackbar({message: "payment Cycle and Status can not be empty", type: 'error'}))
    }
    const handleOnDownload = (items) => {
        setOpenUpdateParollDialog(true)
        setPaymentCycleSelectType('summary')
    }
    const handleSelectedItems = (items) => {
        setSelectedItem(items);

    }
    const handledataloading = (status) => {
        setIsDataLoading(status);

    }
    const handleCreateSubmit = () => {
        setPayrollDialogType('new');
        setOpenPayrollAdjustmentDialog(true)
    }
    const handleRefresh = () => {
        if (!_.isNil(selectedPaymentCycle) && status > 0)
            handleOnsearch([selectedPaymentCycle, status, award, adjustmentType], [amountFrom, amountTo, driverId], warehouses);
    }
    const handleSubmitReivew = (status) => {
        setIsDataLoading(true)
        let param = {
            selected_status: status,
            operator: userPref.userId,
            payroll_cycle: searchedPayrollCyle,
            adjustments: selectedItem.toString()
        }
        dispatch(updateBatchPayroll(param))
            .then((res) => {
                dispatch(showAlertSnackbar({message: res?.success_updated_ids, type: 'success'}))
                setOpenUpdateParollDialog(false)
                handleRefresh()
            })
            .catch((err) => {
                dispatch(showAlertSnackbar({message: err.message, type: 'error'}))
            })
            .finally(() => {
                setIsDataLoading(false);
            })
    }
    const handleClickButtonACtion = (type) => {
        if (type === 0) {
            handleCreateSubmit()
        }
        if (type === 1) {
            if (ableManagerAccess === true && status === 2){
                setOpenUpdateParollDialog(true)
                setPaymentCycleSelectType('approve')
            }
            else
                handleSubmitReivew(1)
        }
    }
    const handleRowClick = (selectedRow) => {
        setIsDataLoading(true);
        setPayrollDialogType('review');
        dispatch(viewPayroll(selectedRow.id))
            .then((res) => {
                if (_.isNil(res[0])) {
                    dispatch(showAlertSnackbar({message: "No Data Found", type: 'error'}))
                } else {
                    setPayrollDetail(res[0]);
                    setPayrollFileDetail(res?.files);
                }
            })
            .catch((err) => {
                dispatch(showAlertSnackbar({message: err.message, type: 'error'}))
            })
            .finally(() => {
                setIsDataLoading(false);
            })
        setOpenPayrollAdjustmentDialog(true)
    }
    const deletePayRollTicket = () => {
        let params = {
            id: deleteEntryID,
            operator: userPref.userId
        }
        dispatch(deletePayroll(params))
            .then((res) => {
                dispatch(showAlertSnackbar({message: res, type: 'success'}))
                handleDialogClose()
                handleRefresh()
            })
            .catch((err) => {
                dispatch(showAlertSnackbar({message: err.message, type: 'error'}))
            })
            .finally(() => {
                setOpenDeleteDialog(false)
            })
    }
    const handleDialogClose = () => {
        setIsDataLoading(false)
        setOpenPayrollAdjustmentDialog(false)
        setPayrollDialogType()
    }
    const handleUpdatePayrollDialogClose = () => {
        setOpenUpdateParollDialog(false)
    }
    const handleMangerApprove = (entyID) => {
        setSelectedItem([entyID])
        setOpenUpdateParollDialog(true)
        setPaymentCycleSelectType('approve')
    }
    const handleDeleteEntity = (entyID) => {
        setOpenDeleteDialog(true)
        setDeleteEntryID(entyID)
    }
    const handleSubmitApprove = (payrollCyle) => {
        setIsDataLoading(true)
        if (paymentCycleSelectType === 'approve') {
            let param = {
                selected_status: status,
                operator: userPref.userId,
                payroll_cycle: payrollCyle,
                adjustments: selectedItem.toString()
            }
            dispatch(updateBatchPayroll(param))
                .then((res) => {
                    dispatch(showAlertSnackbar({message: res.success_updated_ids, type: 'success'}))
                    setOpenUpdateParollDialog(false)
                    setOpenPayrollAdjustmentDialog(false)
                    handleRefresh()
                })
                .catch((err) => {
                    dispatch(showAlertSnackbar({message: err.message, type: 'error'}))
                })
                .finally(() => {
                    setIsDataLoading(false)
                })
        } else if (paymentCycleSelectType === 'summary') {
            let param = {
                payment_cycle: payrollCyle
            }
            downloadPayrollExcelBlob(param)
                .catch((error) => {
                    if (error?.status === 200) {
                        dispatch(showAlertSnackbar({message: t('no_data'), type: 'warning'}))
                    } else {
                        dispatch(showAlertSnackbar({message: t('fetch_error'), type: 'error'}))
                    }
                })
                .finally(() => {
                    setIsDataLoading(false);
                })
        }
    }

    useEffect(() => {
        const branchTimezone = _.filter(
            Object.values(JSON.parse(window.localStorage.getItem('branches'))), (item) => {
                return item.city === parseInt(window.localStorage.getItem('user_city'));
            })
        if (!_.isEmpty(branchTimezone)) {
            setTimezone(branchTimezone[0]?.time_zone)
        }
        dispatch(getPaymentCycle())
            .then((res) => {
                let arr = _.cloneDeep(payRollList);
                arr[0].list = res;
                setPayRollList(arr);
            })
            .catch(() => {
                setIsDataLoading(false);
            })
            .finally(() => {
            })
        dispatch(getChargeReason())
            .then((res) => {
                setChargeReason(res);
            })
            .catch(() => {
                setIsDataLoading(false);
            })
    }, []);
    useEffect(() => {
        if (!_.isEmpty(selectedItem)) {
            if (status === 2) {
                if (ableManagerAccess === true)
                    setDisableSubmitButton(false);
                else
                    setDisableSubmitButton(true);
            }
            if (status === 1) {
                setDisableSubmitButton(false);
            }
            if (status === 3 || status === 0) {
                setDisableSubmitButton(true);
            }
        } else {
            setDisableSubmitButton(true);
        }
    }, [selectedItem, status]);

    return (
        <Box className={classes.root}>
            <SearchActionsSection
                selectListGroup={payRollList}
                inputList={payRollInput}
                buttonGroup={ableManagerAccess === true ? payRollManagerButton : payRollAssitantButton}
                isSelected={selected}
                type={manageIndex}
                onSearch={handleOnsearch}
                onDownload={handleOnDownload}
                handleCreateSubmit={handleCreateSubmit}
                handleClickButtonACtion={handleClickButtonACtion}
                selectedItem={setSelectedItem}
                disableSubmitButton={disableSubmitButton}
                status={status}
                chargeReason={chargeReason}
                ableManagerAccess={ableManagerAccess}
            />
            <PayRollTableSection
                allDriverDetails={allDriverDetails}
                isDataLoading={isDataLoading}
                setSelectedItems={handleSelectedItems}
                handleRowClick={handleRowClick}
                timezone={timezone}
            />
            <PaymentAdjustmentDialog
                chargeReason={chargeReason}
                payrollDialogType={payrollDialogType}
                handleDialogClose={handleDialogClose}
                open={openPayrollAdjustmentDialog}
                ableManagerAccess={ableManagerAccess}
                isDataloading={isDataLoading}
                payrollDetail={payrollDialogType === 'review' ? payrollDetail : []}
                payrollFileDetail={payrollDialogType === 'review' ? payrollFileDetail : []}
                handleMangerApprove={handleMangerApprove}
                handleDeleteEntity={handleDeleteEntity}
                handleRefresh={handleRefresh}
                handledataloading={handledataloading}
                statusList={payRollList[1]}
                timezone={timezone}
            />
            <SelectPayrollDialog
                selectListGroup={payRollList}
                selectItem={selectedItem}
                userId={userPref.userId}
                openUpdateParollDialog={openUpdateParollDialog}
                isDataLoading={isDataLoading}
                paymentCycleSelectType={paymentCycleSelectType}
                handleUpdatePayrollDialogClose={handleUpdatePayrollDialogClose}
                status={status}
                handleSubmitApprove={handleSubmitApprove}
            />
            <UniDialog
                title={t('delete_this_entry')}
                fullWidth
                maxWidth='sm'
                disableDefaultButtons
                open={openDeleteDialog}
                onClose={() => {
                    setOpenDeleteDialog(false)
                }}
            >{
                t('delete_tips')}
                <Grid container style={{marginTop: 40, marginBottom: 10}}>
                    <Grid item xs={8}>
                    </Grid>
                    <Grid item xs={2}>
                        <Button
                            variant="text"
                            color="primary"
                            onClick={() => {
                                setOpenDeleteDialog(false)
                            }}
                        >
                            {t('cancel')}
                        </Button>
                    </Grid>
                    <Grid item xs={2}>
                        <Button
                            variant="text"
                            color="primary"
                            onClick={() => {
                                deletePayRollTicket()
                            }}
                        >
                            {t('yes')}
                        </Button>
                    </Grid>
                </Grid>
            </UniDialog>
        </Box>
    );
}

export default PayrollAdjustmentTable;